export const load = () => ({
	title: 'Local Law 97 & What It Means for Sustainability in NYC',
	showTitle: true,
});
